import React, { useState } from "react";

const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      {/* Navigation Header */}
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <a
                  href="https://www.tradegrowthsolutions.com"
                  className="text-xl font-bold text-gray-800"
                >
                  Trade<span className="text-yellow-600">Growth</span>
                </a>
              </div>
            </div>

            {/* Navigation Links */}
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a
                  href="https://www.tradegrowthsolutions.com#how-it-works"
                  className="text-gray-600 hover:text-yellow-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  How It Works
                </a>
                <a
                  href="https://www.tradegrowthsolutions.com#about"
                  className="text-gray-600 hover:text-yellow-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  About
                </a>
                <a
                  href="https://www.tradegrowthsolutions.com#testimonials"
                  className="text-gray-600 hover:text-yellow-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  Success Stories
                </a>
                <a
                  href="https://www.tradegrowthsolutions.com#faq"
                  className="text-gray-600 hover:text-yellow-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  FAQ
                </a>
                <a
                  href="https://www.tradegrowthsolutions.com/contact"
                  className="text-gray-600 hover:text-yellow-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  Contact
                </a>
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="text-gray-600 hover:text-yellow-600 p-2"
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a
                href="https://www.tradegrowthsolutions.com#how-it-works"
                className="text-gray-600 hover:text-yellow-600 block px-3 py-2 text-base font-medium transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                How It Works
              </a>
              <a
                href="https://www.tradegrowthsolutions.com#about"
                className="text-gray-600 hover:text-yellow-600 block px-3 py-2 text-base font-medium transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About
              </a>
              <a
                href="https://www.tradegrowthsolutions.com#testimonials"
                className="text-gray-600 hover:text-yellow-600 block px-3 py-2 text-base font-medium transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Success Stories
              </a>
              <a
                href="https://www.tradegrowthsolutions.com#faq"
                className="text-gray-600 hover:text-yellow-600 block px-3 py-2 text-base font-medium transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                FAQ
              </a>
              <a
                href="https://www.tradegrowthsolutions.com/contact"
                className="text-gray-600 hover:text-yellow-600 block px-3 py-2 text-base font-medium transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Contact
              </a>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default NavBar;
